const baseUrl = '/residencies';
export const residenciesRoutes = {
  baseUrl: "".concat(baseUrl),
  searchResidenciesAggregate: "".concat(baseUrl, "/search"),
  residenciesRelatedToSpecificBuilding: id => "/buildings/".concat(id, "/residencies"),
  residenciesRelatedToSpecificBuildingV2: id => "/buildings/".concat(id, "/residenciesv2"),
  // NOTE: relates to aggrega api
  aggregateResidencies: "residencies",
  batchOccupancy: "".concat(baseUrl, "/batch/occupancy"),
  addendums: propertyId => "".concat(baseUrl, "/addemdums/").concat(propertyId),
  addendumsV2: propertyId => "".concat(baseUrl, "/addendumsv2/").concat(propertyId),
  leaseDetails: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/lease-details"),
  overview: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/overview"),
  notes: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/notes"),
  occupancy: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/occupancy"),
  billingsettings: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/billingsettings-v2"),
  billingsettingsLegacy: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/billingsettings"),
  moveOut: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/move-out"),
  papercorrespondencesettings: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/papercorrespondencesettings"),
  resendPaperInvitation: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/resend-paper-invitation"),
  resendPaperStatement: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/resend-paper-statement"),
  addresses: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/addresses"),
  updateOrDeleteResidencyAddress: (residencyId, residencyAddressId) => "".concat(baseUrl, "/").concat(residencyId, "/addresses/").concat(residencyAddressId),
  updateResidencyAddressStatus: (residencyId, residencyAddressId) => "".concat(baseUrl, "/").concat(residencyId, "/addresses/").concat(residencyAddressId, "/status"),
  disablePrimary: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/addresses/disable-primary"),
  batchUpdateBillingSettings: "".concat(baseUrl, "/batch-update-billing-settings")
};